import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'
import { useCallback } from 'react'

import { FilterArea } from 'core-components/library/list/filterArea'
import { IDataProviderFilter, IFilter } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { CountriesOfBusinessFilters } from './components/countriesOfBusinessFilters/CountriesOfBusinessFilters'
import { CountryOfBusinessFilter } from './components/countryOfBusinessFilter/CountryOfBusinessFilter'
import { OtherFilters } from './components/otherFilters/OtherFilters'
import { PanelContent } from './components/panelContent/PanelContent'
import { isIDataProviderFilter } from './helpers/isIDataProviderFilter'
import { isIFilter } from './helpers/isIFilter'

interface IFilterAreaProps {
  source: Crud<IFormProfile>
  ignoredFields: string[]
}

export const ContactFilterArea = ({ source, ignoredFields }: IFilterAreaProps) => {
  const onFilterRednerHandler = useCallback((filter: IDataProviderFilter | IFilter) => {
    const isOnlyCountryOfBusinessFilter =
      filter && isIFilter(filter) && filter.field === 'CountryOfBusiness'

    const isSomeCountriesOfBusinessFilter =
      filter &&
      isIDataProviderFilter(filter) &&
      filter.filters[0] &&
      isIFilter(filter.filters[0]) &&
      filter.filters[0].field === 'CountryOfBusiness'

    const isDisjunctionFilter = filter && isIDataProviderFilter(filter)

    if (isOnlyCountryOfBusinessFilter) {
      return <CountryOfBusinessFilter filter={filter as IFilter} />
    }
    if (isSomeCountriesOfBusinessFilter) {
      return <CountriesOfBusinessFilters filter={filter as IDataProviderFilter} />
    }
    if (isDisjunctionFilter) {
      return <OtherFilters filter={filter as IDataProviderFilter} />
    }
    return undefined
  }, [])

  return (
    <FilterArea<IFormProfile>
      source={source}
      PanelContent={PanelContent}
      ignoredDefaultFields={ignoredFields}
      onFilterRender={onFilterRednerHandler}
    />
  )
}
